import { APIAuthClient, APIClient } from 'service/apicataleg/api/APIHttpClient';
import {
  OrderCreationResult,
  OrderDTO,
  OrdersQueryResponse,
} from 'service/apicataleg/types/ApiCatalegTypes';
import { APIOrderClient } from 'service/apicataleg/useApiUser';

const OrderClientService: APIOrderClient = {
  async getOrders(year: number, month: number, npes: string): Promise<OrdersQueryResponse | null> {
    try {
      const { data } = await APIAuthClient.get<OrdersQueryResponse>(
        `/client/orders?year=${year}&month=${month}&npes=${npes}`,
      );
      return data;
    } catch (error) {
      return null;
    }
  },

  async getOrder(npe: number): Promise<OrderDTO | null> {
    try {
      const { data } = await APIAuthClient.get(`/client/orders/${npe}`);
      return data;
    } catch (error) {
      return null;
    }
  },

  async getOrderFile(npe: number): Promise<Blob> {
    const response = await APIAuthClient.get<Blob>(`/client/orders/${npe}/download`, {
      responseType: 'blob',
    });
    const { data } = response;
    return data;
  },
};

export default OrderClientService;
